import React from 'react';
import Error from 'next/error';
import { format, parseISO } from 'date-fns';

import { getLayout, IPrismicLayout } from 'providers/prismic/layout';
import { getEventBySlug } from 'providers/prismic/events';
import { IEvent } from 'providers/prismic/events';
import { getSlugByLocaleAndType } from 'providers/prismic/utils/getSlugsByLocaleAndType';
import { localeToLang } from 'providers/prismic/utils/localeToLang';
import { Layout } from 'containers/layout/Layout';
import { Slices } from 'containers/slices/Slices';
import { useRouter } from 'next/router';
import { Header } from 'components/header/Header';
import { Event as EventLayout } from 'components/event/Event';
import { RichText } from 'components/rich-text/RichText';
import { createSlug } from 'providers/prismic/utils/createSlug';
import { ArticleHero } from 'components/hero/ArticleHero';
import { config } from 'utils/config';

type Props = {
  preview?: boolean;
  layout: IPrismicLayout;
  event: IEvent;
  url: string | null;
};

export default function Event({ preview, layout, event, url }: Props) {
  const { isFallback } = useRouter();

  console.log(event);

  if (isFallback) {
    return <Loading />;
  }

  if (!event) {
    return <Error statusCode={404} />;
  }

  return (
    <Layout
      layout={layout}
      seo={{
        title: event.seo?.title || event.title,
        description: event.seo?.description,
        image: event.seo?.image,
        canonicalUrl: url,
      }}
      header={<Header showNavigation={layout.navigationMain.length > 0} />}
      hasFooter
      isPadded
      preview={preview}
    >
      <ArticleHero
        title={event.title}
        // tagline={event.tagline}
        date={event.startDate}
        image={event.image}
        // caption={article.caption}
        // back="/"
        // backLabel="Back to Events"
      />
      <EventLayout
        video={event.video}
        presentation={event.investorPresentation}
        startDateTime={event.startDate}
        endDateTime={event.endDate}
        startDate={format(Date.parse(event.startDate || ''), 'd MMMM yyyy')}
        endDate={format(Date.parse(event.endDate || ''), 'd MMMM yyyy')}
        letter={event.shareholderLetter}
        webcast={event.webcast}
        address={event.address && <RichText render={event.address} />}
        booth={event.booth}
      >
        <Slices slices={event.slices} isEvent />
      </EventLayout>
    </Layout>
  );
}

const Loading = () => <p>Loading...</p>;

export async function getStaticProps({ params, preview = false, previewData, locale, locales }) {
  const lang = localeToLang(locale);

  console.log(params.slug);

  const layout = await getLayout({ previewData, lang });
  const event = await getEventBySlug(params.slug, {
    previewData,
    lang,
    redirects: layout?.redirects,
  });

  const url = createSlug({
    includeSiteUrl: true,
    lang: lang,
    id: event?.id,
    uid: event?.uid,
    layouts: [layout],
  });

  return {
    props: {
      preview,
      layout,
      event,
      url,
    },
    notFound: !event,
    revalidate: config.revalidate,
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}
